import React from "react";
import { useTranslation } from "lib/i18n";
import Seo from "components/Seo";

const ThankYou = () => {
  const { t, language } = useTranslation();
  const isFrench = language === "fr";
  const title = isFrench ? "Merci" : "Thank You";
  const description = isFrench
    ? "Merci d'avoir contacté Quivio."
    : "Thanks for reaching out to Quivio.";
  return (
    <>
      <Seo title={title} description={description} path="/thank-you" noIndex />
      <div className="contact section-title mt-5">
        <div className="container text-white">
          <div className="row align-items-center">
            <div className="col-md-7 mx-auto">
              <div className="contact-title mb-5 mt-5">
                <h1 className="title-font title-font-size">{t("thankYou.heading")}</h1>
                <p className="mt-4 mb-4 title-font-2">
                  {t("thankYou.message")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThankYou;
